import "./HomeOccasionsContainer.css";
import React from "react";
import { useNavigate } from "react-router-dom";

const HomeOccasionsContainer = ({
  occasionsInfoList,
  selectedCountry,
  backgroundImageUrl,
}) => {
  const navigate = useNavigate();
  const handleClick = (url) => {
    navigate(url);
  };

  return (
    <div
      className="home-occasions-container"
      style={{
        backgroundImage: `url(${backgroundImageUrl})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }}
    >
      {occasionsInfoList.map((occasionInfo, index) => (
        <div
          className="home-occasions-item"
          style={{
            cursor: "pointer",
          }}
          key={occasionInfo.id}
          onClick={() => handleClick(occasionInfo.url)}
        >
          <div className="home-occasions-nested">
            <div>
              <p className="home-occasions-product-title">
                {occasionInfo.title}
              </p>
            </div>
            <div className="home-occasions-image-container">
              <img
                src={occasionInfo.imageUrl}
                alt={occasionInfo.imageAlt}
                style={{ marginTop: "5px" }}
                loading="lazy"
              />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default HomeOccasionsContainer;
